import React, { MouseEventHandler } from 'react';
import useHover from '../../hooks/useHover';
import { MarkerNumberData } from '../../types/MapMarker';
import { textColorForBg } from '../../utils/color.utils';
import './MarkerNumber.scss';

type MarkerNumberProps = {
  lat: number;
  lng: number;
  data: MarkerNumberData;
  onClick?: MouseEventHandler<HTMLDivElement>;
};

const DEFAULT_COLOR = '#f0f0f0';

function MarkerNumber({ data: { number, description, color }, onClick }: MarkerNumberProps) {
  const { isHovered, hoverProps } = useHover();
  const bgColor = color ?? DEFAULT_COLOR;
  const textColor = textColorForBg(bgColor);

  return (
    <>
      <div
        className='marker-emoji-container'
        {...hoverProps}
        onClick={onClick}
      >
        <div className='marker-emoji-pin'>
          <img
            className='marker-emoji'
            alt={description}
            src='/svgs/map-marker-highlighted.svg'
          />
        </div>
        <span
          className='marker-number-text'
          style={{ backgroundColor: bgColor, color: textColor }}
        >
          {number}
        </span>
      </div>
      {isHovered && (
        <div className='marker-description-container'>
          <span>
            {description.length > 37 ? `${description.substring(0, 37)}...` : description}
          </span>
        </div>
      )}
    </>
  );
}

MarkerNumber.displayName = 'MarkerNumber';
export default MarkerNumber;
